import React from "react";
import Image from "next/image";
import ModalWithTopBar from "~/shared/ModalWithTopBar";
import { ModalContent } from "./styles";
import Button from "~/shared/Btn";
import useAuth from "~/hooks/useAuth";

type WarningModalProps = {
    isOpen: boolean;
    onHide: () => void;
    redirectFn: () => void;
    owner?: boolean;
};

const WarningModal = ({ isOpen, onHide, owner = false, redirectFn }: WarningModalProps) => {
    const { logout } = useAuth();
    return (
        <ModalWithTopBar isOpen={isOpen} onHide={onHide} blockModal>
            <>
                <ModalContent owner={owner}>
                    <div className="img">
                        <Image
                            src="/images/warning.svg"
                            alt="imagem de alerta"
                            layout="responsive"
                            width={311}
                            height={227}
                        />
                    </div>
                    <div className="content">
                        <h1>Você quer fazer um pedido no marketplace?</h1>
                        <div>
                            <p>
                                Você acessou o fluxo de solicitação de job no <span>Marketplace Fotop serviços</span>,
                                mas seu email está vinculado a uma organização do Fotop Serviços Business e você não
                                pode seguir com o pedido aqui enquanto estiver logado. Nesse fluxo, você envia a sua
                                solicitação e recebe propostas dos fotógrafos cadastrados, e a negociação é feita entre
                                vocês, até a escolha do portfólio e o pagamento do job.
                            </p>

                            {/* {owner ? (
                            <strong>
                            Se estiver correto basta clicar em continuar. Caso você queira agendar um job
                            imobiliário para a sua empresa na conta mensal gerenciada pelo Fotop, acesse o painel do
                            Fotop Serviços Business.
                            </strong>
                            ) : (
                                ""
                            )} */}

                            <div className="links">
                                <a
                                    href="https://fotop.movidesk.com/kb/article/360504/faq-marketplace-fotop-servicos-c?preview=true&revisionId=1353870"
                                    target="_blank"
                                >
                                    <span>Dúvidas e FAQ </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </ModalContent>
                <div className="buttons">
                    <Button block variant="success" onClick={logout}>
                        Entrar com outro email
                    </Button>
                    <Button block variant="primary" onClick={redirectFn}>
                        Voltar ao painel do cliente
                    </Button>
                </div>
            </>
        </ModalWithTopBar>
    );
};

export default WarningModal;
